// extracted by mini-css-extract-plugin
export default {"cardBody":"Messages_cardBody__nD-8O","count":"Messages_count__0t+5w","search":"Messages_search__q+iGT"};